import React from "react";

// WhatsApp-style formatting: *asterisks* render bold, _underscores_ render italic, same
// as WhatsApp's own chat formatting. Neither allows space right inside the markers
// (mirrors WhatsApp's rule), so "3 * 4" is left untouched. Italic additionally requires
// whitespace (or start/end of string) immediately outside each underscore -- otherwise
// "abc_sdd_dfg" would italicize "sdd" even though there's no word-boundary around it.
// The leading boundary is captured (group 2) so it can be re-emitted as plain text, since
// it isn't part of the italic content itself; the trailing boundary is a lookahead so it
// isn't consumed and stays available for the next segment.
const FORMAT_PATTERN = /\*(\S(?:[^*]*\S)?)\*|(^|\s)_(\S(?:[^_]*\S)?)_(?=\s|$)/g;

/** Splits `text` into plain strings plus bold/italic elements per WhatsApp's asterisk/underscore markers. */
export function renderWhatsAppFormattedText(text, keyPrefix = "") {
  if (!text || typeof text !== "string" || (!text.includes("*") && !text.includes("_"))) return text;
  const segments = [];
  let lastIndex = 0;
  let match;
  let idx = 0;
  FORMAT_PATTERN.lastIndex = 0;
  while ((match = FORMAT_PATTERN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push(text.substring(lastIndex, match.index));
    }
    if (match[1] !== undefined) {
      segments.push(<strong key={`${keyPrefix}b${idx++}`}>{match[1]}</strong>);
    } else {
      // match[2] is the boundary character consumed before the opening underscore (a space,
      // or "" at start-of-string) -- put it back as plain text, it isn't italic content.
      if (match[2]) segments.push(match[2]);
      segments.push(<em key={`${keyPrefix}i${idx++}`}>{match[3]}</em>);
    }
    lastIndex = FORMAT_PATTERN.lastIndex;
  }
  if (lastIndex < text.length) {
    segments.push(text.substring(lastIndex));
  }
  return segments.length ? segments : text;
}
